export default class pagerManager {
    constructor(){

        this.$dheader = $(".headerglobalnavi");

    }
    open(_status,_pagerStatus){
        _status.Flg = true;
        if(!Useragnt.module){
            _pagerStatus._pagerText = 'CLOSE';
            _pagerStatus.$pagerTrigger.find('.text').text(_pagerStatus._pagerText);

        }
        _pagerStatus.$pagerTrigger.addClass('js__open');
        TweenMax.fromTo(_pagerStatus.$pagerContent, .45, {
            x: '-10px',
            autoAlpha: 0,
            display:'none'
        },{
            x:0,
            autoAlpha: 1,
            display:'block',
            easing:Expo.easeOut,
            onComplete:function(){
                _pagerStatus._pagerOpen = true;
            }
        });
        TweenMax.to(this.$dheader, .48,{
            y:-(this.$dheader.height() + 15),
            ease: this.ease,
        });
    }
    close(_status,_pagerStatus){
        if(!Useragnt.module){
            _pagerStatus._pagerText = 'MENU';
            _pagerStatus.$pagerTrigger.find('.text').text(_pagerStatus._pagerText);
        }
        _pagerStatus.$pagerTrigger.removeClass('js__open');
        TweenMax.to(_pagerStatus.$pagerContent, .45, {
            x: '-10px',
            autoAlpha: 0,
            display:'none',
            easing:Expo.easeOut,
            onComplete:function(){
                _pagerStatus._pagerOpen = false;
                _status.Flg = false;
            }
        });
        TweenMax.to(this.$dheader, .48,{
            y:'0',
            ease: this.ease,
        });
    }
    move(_status){
    }
}

